<template>
  <div class="form-group">
    <tc-email class="tc-icon fs-unmask" />
    <label
      class="fs-unmask"
      for="login-email"
    >
      {{ $t('login.form.email') }}
    </label>
    <input
      id="login-email"
      v-validate="'required|email'"
      :value="userName"
      name="email"
      type="text"
      class="form-control username playback-hide"
      placeholder="me@example.com"
      @input="setUserName($event.target.value)"
    >
  </div>
</template>

<script>
import TcEmail from '@/components/shared/icons/TcEmail'

export default {
  name: 'UserNameLogin',
  components: {
    TcEmail
  },
  props: {
    userName: {
      type: String,
      required: true
    }
  },
  methods: {
    setUserName (username) {
      this.$emit('update-user-name-login', username)
    }
  }
}
</script>

<style scoped lang="scss">
  @import 'Login';

</style>
